import Icon from '@mdi/react';
import { mdiCloseCircleOutline  } from '@mdi/js';

const FullWeeklyForecast = ({fullWeeklyWeather, days, handleClick}) => {
  return ( 
    <div>
      <div className="pt-3 px-4 m-2 mt-6 flex flex-row justify-between align-middle">
        <h1 className="text-3xl self-center">
          {  days[new Date(fullWeeklyWeather.datetime).getDay()] }
        </h1>
          <Icon 
          onClick={() => handleClick(null)}
          color={'white'} className='p-1 self-center hover:bg-white hover:bg-opacity-25 hover:cursor-pointer rounded-full' path={mdiCloseCircleOutline} size={1.35} />
      </div>
      <div className="flex flex-row m-1 mb-8 mx-6 overflow-auto scrollbar-thin">
        { fullWeeklyWeather.hours.map((hour, index) =>  
          <div className="p-2 m-2 mt-0 flex-auto justify-center text-center" key={index}>
            <div>
              <p className='text-base'>{ hour.dateTime.slice(0, -3) }</p>
              <img className='m-2' alt='hail' src={require('./../icons/' + hour.icon + ".png")} style={{marginLeft: "auto", marginRight: "auto"}} width="40px" height="40px"/>
              <p className='text-sm text-nowrap'>{hour.temp} °c</p>
            </div>
          </div> 
        )}
      </div>
    </div>
  );
}
 
export default FullWeeklyForecast;